import { EventEmitter } from "events";

type ToastMode = "success" | "error";

interface ToastEvent {
  message: string;
  mode: ToastMode;
}

class ToastEmitter extends EventEmitter {
  showToast(message: string, mode: ToastMode = "success") {
    this.emit("toast", { message, mode });
  }
}

export const toastEmitter = new ToastEmitter();
